/*
 * @Description: 国际化-中文，此处导入并统一导出所有页面或组件的国际化文件配置，多层json结构防止冲突并使结构更清晰
 * @Author: 刘宝顺
 * @Date: 2024-01-15 10:26:30
 * @LastEditTime: 2024-02-01 14:28:21
 * @LastEditors: 刘宝顺
 */

import commonI18n from './common/zh-CN.json';
import downloadI18n from '@/pages/download/local/zh-CN.json';

const zhCN = {
    common: commonI18n,
    pages: { download: downloadI18n },
    components: {},
};

export default zhCN;
